import BlockTitle from "@components/cms/BlockTitle/BlockTitle";
import i from "@styles/icons.module.scss";
import Container from "@ui-kit/Container/Container";
import Slider from "@ui-kit/Slider/Slider";
import SliderControls from "@ui-kit/Slider/SliderControls";
import SliderSlides from "@ui-kit/Slider/SliderSlides";

import { typeSlider } from "./datas";
import s from "./GaleryV4Block.module.scss";

const GaleryV4Block = ({ settings, data, updateField }) => {
  const { title, collections } = data;
  const { sliderV4 } = collections;
  const { items } = sliderV4;
  const { blockType } = settings.common;

  const filteredItems = items.filter((item) => {
    return typeof item.isShow === "boolean" ? item.isShow : true;
  });

  return (
    <Container className={s.galeryV4}>
      <Container full={false}>
        <section>
          <BlockTitle
            settings={settings}
            field={{ title }}
            onChange={updateField}
            type={blockType}
          />
          <Slider
            collectionType={typeSlider}
            // autoScroll
            slidesCount={filteredItems.length}
            className={s.slider}
            render={(sliderProps) => {
              return (
                <>
                  <SliderSlides {...sliderProps} className={s.slides}>
                    {filteredItems.map((item, key) => (
                      <div key={key} className={s.slide}>
                        <div className={s.quote}>
                          <icon className={i.quote} />
                          <p>{item.quote}</p>
                        </div>
                        <h5 className={s.author}>{item.firstName}</h5>
                      </div>
                    ))}
                  </SliderSlides>
                  <SliderControls className={s.controls} {...sliderProps} />
                </>
              );
            }}
          />
        </section>
      </Container>
    </Container>
  );
};

export default GaleryV4Block;
